export enum ETitleSize {
	SMALL = 'small',
	MEDIUM = 'medium',
	LARGE = 'large',
}
